import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// VeeValidate
import VeeValidate from 'vee-validate';
import { Validator } from "vee-validate";
Vue.use(VeeValidate);

// Vue Toasted
import Toasted from 'vue-toasted';

let toastedOptions = {
  position : 'bottom-right',
  duration : 2000,
  closeOnSwipe: true
};
Vue.use(Toasted, toastedOptions);

Vue.toasted.register('success_toast',
  (payload) => {
      return payload.message || "La operación se realizó satisfactoriamente!";
  },
  {type: 'success'}
);

Vue.toasted.register('info_toast',
  (payload) => {
      return payload.message || '';
  },
  {type: 'info'}
);

Vue.toasted.register('error_toast',
  (payload) => {
      return payload.message || "Error al realizar la operación";
  },
  {type: 'error'}
)

const dictionary = {
  en: {
    messages:{
      required: (field) => `El campo es requerido.`,
      alpha: (field) => `El campo debe contener solo caracteres alfabéticos.`,
      alpha_spaces: (field) => `El campo debe contener solo caracteres alfabéticos y espacios.`,
      numeric: (field) => `El campo debe contener solo caracteres numéricos.`,
      digits: (field, params) => `El campo debe contener solo caracteres numéricos y exactamnete ${params[0]} dígitos.`,
      min: (field, params) => `El campo debe contener al menos ${params[0]} caracteres.`,
      max: (field, params) => `El campo no debe contener más de ${params[0]} caracteres.`,
      length: (field, params) => `El campo debe contener ${params[0]} caracteres.`,
      email: (field) => `El campo debe ser un Correo Electrónico valido.`,
    }
  }
};

// Override and merge the dictionaries
Validator.localize(dictionary);

//Custom Rules
Validator.extend('isNotYuliEmail', {
  getMessage: (field) => `El Correo Electrónico no puede ser '@unc.edu.ar ni @mi.unc.edu.ar'.`,
  validate: (value) => {
    if ( /^(?!.*@unc\.edu\.ar).*$/.test(value) && /^(?!.*@mi\.unc\.edu\.ar).*$/.test(value) ) {
      return true
    } else {
      return false
    }
  }
});

Validator.extend('requireNumber', {
  getMessage: (field) => 'Debe contener al menos un número.',
  validate: (value) => {
    return  /\d{1}/.test(value);
  }
});

Validator.extend('requireLowerCase', {
  getMessage: (field) => 'Debe contener al menos una minúscula.',
  validate: (value) => {
      return  /\d{1}/.test(value);
  }
});

Validator.extend('requireUpperCase', {
  getMessage: (field) => 'Debe contener al menos una mayúscula.',
  validate: (value) => {
      return  /\d{1}/.test(value);
  }
});
//Fin VeeValidate

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import vueScrollto from 'vue-scrollto'
Vue.use(vueScrollto)

// FILTERS
Vue.filter('toArgDate', function (value) {
  let newValue = ''
  if (value) {
    let data = value.split('T');
    if (data.length > 0) {
      let dataArray = data[0].split('-');
      newValue =  `${dataArray[2]}/${dataArray[1]}/${dataArray[0]}`;   
    }
  } else {
    newValue = '';
  } 

  return newValue;
})
//Fin Filters

//Plugins
import './../node_modules/jquery/dist/jquery.min.js'
import './../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './../node_modules/bootstrap/dist/js/bootstrap.min.js'

//datePicker
import datePicker from 'vue-bootstrap-datetimepicker';
import './../node_modules/eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'  
Vue.use(datePicker);

//import './assets/vendors/jquery.easy-pie-chart/dist/jquery.easypiechart.min.js'

//Select
import './assets/vendors/bootstrap-select/dist/js/bootstrap-select.min'
import './assets/vendors/bootstrap-select/dist/css/bootstrap-select.min.css'

import swal from './../node_modules/sweetalert2/dist/sweetalert2.min.css'
import './../node_modules/animate.css/animate.min.css'
//import './../node_modules/jquery.nicescroll/dist/jquery.nicescroll.min.js'

//Fonts
import './../node_modules/roboto-fontface/css/roboto/roboto-fontface.css'
import './../node_modules/material-design-iconic-font/dist/css/material-design-iconic-font.min.css'

//Custom Style

import '../src/assets/scss/my-listview/my-listview.scss'
import '../src/assets/scss/my-form/my-form.scss'
import '../src/assets/scss/my-modal/my-modal.scss'
import '../src/assets/scss/my-app/my-app.scss'
import '../src/assets/scss/my-view-block/my-view-block.scss'
import '../src/assets/scss/my-menu/my-menu.scss'
import '../src/assets/css/app-core.css'
import '../src/assets/css/app-ecart.css'


import '../src/assets/scss/landing.scss'


//JS
import './assets/js/app-core.js'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
